import Link from 'next/link'
import { RichText } from 'prismic-reactjs'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { headlineMediumStyles } from '../../../utils/cmsStyles'
import Button from '../../Button'

import Container from '../../Container'
import Display from '../../Display'
import { anchorStyle } from '../../GlobalStyle'
import Text from '../../Text'

const Hero = ({ data, ctaHref }) => {
  const {
    headline,
    subheading,
    image: {
      url: desktopImageUrl
    },
    inviteCodeHref
  } = data
  return (
    <Wrapper desktopBg={desktopImageUrl}>
      <HeroSection>
        <Title size="medium">{RichText.asText(headline)}</Title>
        <Subheading>{RichText.render(subheading)}</Subheading>
        <CTA>
          <StyledButton buttonHref={ctaHref} />
          <ButtonTip size="small">Checking your rate is free and won’t impact your credit score*</ButtonTip>
          <Link href={inviteCodeHref || '/apply'}><Anchor>I HAVE AN INVITE CODE</Anchor></Link>
        </CTA>
      </HeroSection>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${ ({ theme }) => theme.colors.cream };
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.xs1 }) {
    background-image: url(${ ({ desktopBg }) => desktopBg });
  }

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.xl }) {
    min-height: 750px;
  }
`

const HeroSection = styled(Container)`
  margin: 0 auto;
  text-align: left;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.xs1 }) {
    text-align: center;
  }

  > div {
    padding: 80px 25px 75px;

    @media screen and (min-width: ${ (props) => props.theme.breakpoints.lg }) {
      padding: 145px 50px;
    }
  }

`

const Title = styled(Display)`
  max-width: 645px;
  margin: 0 auto;
`

const Subheading = styled.div`
  ${ headlineMediumStyles }

  p {
    margin: 24px 0 36px;

    @media screen and (min-width: ${ (props) => props.theme.breakpoints.sm }) {
      margin: 32px 0 60px;
    }
  }
`

const CTA = styled.div`
  align-items: center;
  flex-direction: column;
  display: flex;
  text-align: center;
`

const StyledButton = styled(Button)`
  @media screen and (max-width: ${ (props) => props.theme.breakpoints.xs1 }) {
    width: 100%;
  }
`

const Anchor = styled.a`
  ${ anchorStyle }

  @media screen and (max-width: ${ (props) => props.theme.breakpoints.xs1 }) {
    margin: 32px 0 48px;
  }
`

const ButtonTip = styled(Text)`
  order: 2;
  width: 200px;
  margin: 0 auto;

  @media screen and (min-width: ${ ({ theme }) => theme.breakpoints.xs1 }) {
    order: initial;
    width: initial;
    margin: 32px auto;
  }
`

Hero.defaultProps = {
  ctaHref: null,
}

Hero.propTypes = {
  data: PropTypes.shape({
    form_title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    headline: PropTypes.oneOfType([PropTypes.array]),
    subheading: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    image: PropTypes.oneOfType([PropTypes.object]).isRequired,
    inviteCodeHref: PropTypes.string,
    buttonTip: PropTypes.string,
  }).isRequired,
  ctaHref: PropTypes.string,
}

export default Hero
